<div class="auth-wrapper d-flex no-block justify-content-center align-items-center"
    style="background:url(assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div>
            <div class="logo">
                <span class="d-block">
                    <img src="./assets/images/lekha-logo-03.png" style="height: 50px;" alt="logo">
                </span>
                <h5 class="font-medium mb-3">Recover Password</h5>
            </div>
            <!-- Form -->
            <form #mobileAuthetication="ngForm" novalidate>
                <div  *ngIf="!showReset"> 
                <div class="row">
                    <div class="col-12">
                        <form #forgotForm="ngForm">
                            <div class="form-group col-sm-12">
                                <div class="radio">
                                    <label class="form-check-label" for="Gender">UserName:</label> &nbsp;&nbsp;

                                  <input type="radio" id="male" name="gender" [(ngModel)]="userName" value="m" (change)="userNameField()"> Mobile Number &nbsp;&nbsp;
                                  <input type="radio" id="female" name="gender" [(ngModel)]="userName" value="e"  (change)="userNameField()"> Email address
                                </div>
                              </div>
                            <div class="form-group row">
                                <div class="col-12" *ngIf="!showMobile">
                                    <input class="form-control form-control-lg" type="text" required   #emailId="ngModel"
                                    name="emailId"maxlength="40" [(ngModel)]="email" placeholder="Email">
                                     <span style="font-size: small" class="text-danger"
                                     [hidden]="!emailId.errors.required"
                                     *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">This
                                     Field is Required</span>
                                 <span style="font-size: small" class="text-danger"
                                     [hidden]="!emailId.errors.pattern"
                                     *ngIf="emailId.errors && (emailId.touched || emailId.dirty)">Please
                                     Enter Valid Email </span>
                                 <span style="font-size: small" class="text-danger"
                                     [hidden]="!emailId.errors.maxlength || emailId?.errors.pattern"
                                     *ngIf="emailId.errors">
                                     valid email.</span>
                                </div>
                                <div class="col-12" *ngIf="showMobile">
                                    <input type="tel" id="mobileNumber" required
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                    #mobileNumber="ngModel" name="mobileNumber" minlength=10 maxlength=15
                                                    [(ngModel)]="mobilenumber" class="form-control"
                                                    placeholder="Mobile Number">
                                                <span class="text-danger" [hidden]="!mobileNumber.errors.required"
                                                    *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">This
                                                    Field
                                                    is Required
                                                </span>
                                                <span class="text-danger" [hidden]="!mobileNumber.errors?.minlength || mobileNumber.errors.pattern" *ngIf="mobileNumber.errors && (mobileNumber.touched || mobileNumber.dirty)">
                                                    Mobile Number Should not exceed 15 digits</span>
                                </div>
                            </div>
    
                            <div class="row form-group text-center" *ngIf="!show">
                                    <div class="col-12" *ngIf="!showMobile">
                                        <button class="btn btn-block btn-lg bg-gradient-primary text-white" type="submit " [disabled]="!forgotForm.valid" (click)="sendOtp(email)">SEND
                                            OTP</button>
                                    </div>
                                    <div class="col-12" *ngIf="showMobile">
                                        <button class="btn btn-block btn-lg bg-gradient-primary text-white" type="submit " [disabled]="!forgotForm.valid" (click)="sendOtp(mobilenumber)">SEND
                                            OTP</button>
                                    </div>
                                </div>
    
                            <div class="form-group row" *ngIf="show">
                                <div class="col-12" >
                                    <input class="form-control form-control-lg" name="otp" type="password" required=" "  [(ngModel)]="otp" placeholder="OTP">
                                </div>
                               
                            </div>
                            <div class="form-group row" *ngIf="show && !showMobile" style="width: 40%;margin-left: 5px">
                                    <button class="btn btn-block btn-lg bg-gradient-primary text-white" (click)="reSendOtp(email)" >Resend OTP
                                    </button>
                                </div>
                                <div class="form-group row" *ngIf="show && showMobile" style="width: 40%;margin-left: 5px">
                                    <button class="btn btn-block btn-lg bg-gradient-primary text-white" (click)="reSendOtp(mobilenumber)" >Resend OTP
                                    </button>
                                </div>
                         
                            <div class="row form-group text-center" *ngIf="show">
                                <div class="col-12">
                                    <button class="btn btn-block btn-lg bg-gradient-primary text-white" type="submit " [disabled]="!mobileAuthetication.valid" (click)="resetForgotForm()">Submit
                                        </button>
                                </div>
                            </div>
                      
                        </form>
                    </div>
                </div>
            </div>
            </form>
            <form #forgotPassword="ngForm" novalidate >
                <div *ngIf="showReset">
                <div class="row">
                    <div class="col-12">
                            <div class="form-group row">
                                <div class="col-12">
                                    <input class="form-control form-control-lg" type="password" #id="ngModel" name="id" required  [(ngModel)]="forgetAddObj.resetPassword"
                                        placeholder="Reset Password">
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-12">
                                    <input class="form-control form-control-lg" type="password" #id="ngModel" name="id" required [(ngModel)]="confirmPassword"
                                        placeholder="Confirm Password">
                                </div>
                            </div>
                            <div class="row form-group text-center">
                                <div class="col-12" *ngIf="!showMobile">
                                    <button class="btn btn-block btn-lg bg-gradient-primary text-white"  [disabled]="!forgotPassword.valid"  (click)="resetPasswordThroughEmail()" >RESET</button>
                                </div>
                                <div class="col-12" *ngIf="showMobile">
                                    <button class="btn btn-block btn-lg bg-gradient-primary text-white"  [disabled]="!forgotPassword.valid"  (click)="resetPasswordThroughMobile()" >RESET</button>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            </form>
            <div *ngIf="showSignIn" class="row form-group mb-0 mt-2">
                            <div class="col-12 text-center ">
                               Password Updated,please
                                <a href="#/ " class="text-primary ml-1">
                                    <b>Sign In
                                    </b>
                                </a>
                            </div>
                        </div>
        </div>
    </div>
</div>